module.exports = __webpack_public_path__ + "img/menu.b1d8e165.svg";